module.exports = __webpack_public_path__ + "img/20180404.d4695d5d.png";